<template>
  <div>
    <h3>创建考试大纲{{ lineID }}</h3>
    <div>
      <el-form @submit.native.prevent="createOutline">
        <!-- <el-form-item label="选择网校">
          <el-select v-model="model.maID" placeholder="网校">
            <el-option
              v-for="item in major"
              :key="item.maID"
              :label="item.maName"
              :value="item.maID"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="一级分类">
          <el-select
            multiple
            v-model="model.chID"
            @change="getCourse"
            placeholder="一级分类"
          >
            <el-option
              v-for="item in channel"
              :key="item.chID"
              :label="item.chName"
              :value="item.chID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类">
          <el-select
            multiple
            v-model="model.coID"
            @change="getClass"
            placeholder="二级分类"
          >
            <el-option
              v-for="item in course"
              :key="item.coID"
              :label="item.coName"
              :value="item.coID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item multiple label="三级分类">
          <el-select v-model="model.clID" multiple placeholder="三级分类">
            <el-option
              v-for="item in shclass"
              :key="item.clID"
              :label="item.clName"
              :value="item.clID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="所属分类">
        <el-select v-model="model.newsID" placeholder="所属分类">
          <el-option
            v-for="item in newscate"
            :key="item.newsID"
            :label="item.newsGroupName"
            :value="item.newsID"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
        <el-form>
          <v-distpicker
            style="margin-bottom: 25px"
            v-model="model"
            :province="model.province"
            :city="model.city"
            :area="model.area"
            @province="selectProvince"
            @city="selectCity"
            @area="selectArea"
          ></v-distpicker>
        </el-form>
        <el-form-item label="请输入大纲标题">
          <el-input v-model="model.lineName"></el-input>
        </el-form-item>
        <el-form-item label="请输入大纲作者/来源">
          <el-input v-model="model.lineAuthor"></el-input>
        </el-form-item>
        <el-form-item label="大纲lineID(自动生成)">
          <el-input
            :disabled="true"
            v-model="lineID"
            @input="createLineID"
          ></el-input>
        </el-form-item>
        <el-form-item label="请输入大纲内容"> </el-form-item>

        <!-- 文本框编辑区域 -->
        <div class="textarea">
          <editor
            v-model="model.lineBody"
            :init="init"
            :disabled="disabled"
            @onClick="onClick"
          ></editor>
        </div>

        <el-form-item style="float: right; margin-top: 15px">
          <el-button type="primary" native-type="submit">点击创建</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/skins/ui/oxide/skin.css";
// 编辑器插件plugins
// 更多插件参考：https://www.tiny.cloud/docs/plugins/

import "tinymce/langs/zh_CN.js";
import "tinymce/plugins/advlist"; //高级列表
import "tinymce/plugins/link"; //超链接
import "tinymce/plugins/autolink"; //自动链接
import "tinymce/plugins/image"; // 插入上传图片插件
import "tinymce/plugins/table"; // 插入表格插件
import "tinymce/plugins/lists"; // 列表插件
import "tinymce/plugins/wordcount"; // 字数统计插件
import "tinymce/plugins/media"; // 插入上传视频插件
import "tinymce/plugins/autosave"; // 自动保存插件
import "tinymce/plugins/preview"; // 预览插件
import "tinymce/plugins/hr"; // 预览插件
import "tinymce/plugins/code"; // 源码插件
import "tinymce/plugins/paste";
import "tinymce/plugins/charmap"; //特殊字符
//import "tinymce/plugins/powerpaste"; //粘贴图片

//import moment from 'moment'

export default {
  components: {
    Editor,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default:
        "lists image table wordcount autosave preview hr advlist autolink link",
    },
    toobar: {
      type: [String, Array],
      default: () => {
        return [
          "link uploadimg image media | undo redo | cut copy paste pastetext | forecolor backcolor bold italic underline hr link anchor | alignleft aligncenter alignright alignjustify outdent indent",
          "styleselect formatselect fontsizeselect",
          "bullist numlist | blockquote subscript superscript removeformat | table image charmap emoticons pagebreak insertdatetime print preview | bdmap indent2em lineheight formatpainter axupimgs",
        ];
      },
      value: {
        type: String,
        default: "",
      },
    },
  },
  data() {
    return {
      lineDataCount: 0,
      currentPage: 1,
      pageSize: 10,
      major: [],
      channel: [],
      course: [],
      shclass: [],
      lineData: [],
      lineID: "",
      model: {
        province: "",
        city: "",
        area: "",
      },
      dialogVisible: false,
      activeName: "first",
      init: {
        selector: "textarea",
        language: "zh_CN",
        convert_urls: false,
        content_style: "img{max-width:50%}",
        height: "80vh",
        plugins: this.plugins,
        toolbar: this.toobar,
        branding: false,
        file_picker_types: "file image media",
        automatic_uploads: true,
        paste_data_images: true,
        powerpaste_word_import: "propmt",
        powerpaste_html_import: "propmt",
        powerpaste_allow_local_images: true,

        /* powerpaste:
          "../../node_modules/tinymce/plugins/powerpaste/plugin.min.js", */

        //images_upload_url: this.$http.defaults.baseURL + "/artic/img/news",

        // menubar: 'file edit',
        // 如需ajax上传可参考https://www.tiny.cloud/docs/configure/file-image-upload/#images_upload_handler
        images_upload_handler: (blobInfo, success, failFun) => {
          /* const imgNews = this.$http.post("/artic/img/news");
          console.log(imgNews); */

          var xhr, formData;

          var file = blobInfo.blob(); //转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", this.$http.defaults.baseURL + "/outline/img/line");

          /* xhr.upload.onprogress = function (e) {
            //progress((e.loaded / e.total) * 100);
          }; */

          xhr.onload = function () {
            var json;
            json = JSON.parse(xhr.responseText);
            if (xhr.status != 200) {
              failFun("HTTP Error: " + xhr.status);
              return;
            }

            if (!json || typeof json.location != "string") {
              failFun("Invalid JSON: " + xhr.responseText);
              return;
            }
            success(json.location);
          };

          formData = new FormData();
          formData.append("file", file, file.name);

          xhr.send(formData);
        },
        file_picker_callback: (callback, value, meta) => {
          //文件分类
          var filetype =
            ".pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx, ";
          //后端接收上传文件的地址
          var upurl = `${this.$http.defaults.baseURL}/outline/file/line`;
          //为不同插件指定文件类型及后端地址
          switch (meta.filetype) {
            case "image":
              filetype = ".jpg, .jpeg, .png, .gif";
              upurl = `${this.$http.defaults.baseURL}/outline/img/line`;
              break;
            /* case "file":
              filetype = ".pdf,.doc, .docx, .xls, .xlsx, .ppt, .pptx,";
              upurl = `${this.$http.defaults.baseURL}/outline/file/line`;
              break; */
          }
          //模拟出一个input用于添加本地文件
          var input = document.createElement("input");
          input.setAttribute("type", "file");
          input.setAttribute("accept", filetype);
          input.click();
          input.onchange = function () {
            var file = this.files[0];

            var xhr, formData;
            console.log(file.name);
            xhr = new XMLHttpRequest();
            xhr.withCredentials = false;
            xhr.open("POST", upurl);
            xhr.onload = function () {
              var json;
              if (xhr.status != 200) {
                console.log("HTTP Error: " + xhr.status);
                return;
              }
              json = JSON.parse(xhr.responseText);
              if (!json || typeof json.location != "string") {
                console.log("Invalid JSON: " + xhr.responseText);
                return;
              }
              callback(json.location);
            };
            formData = new FormData();
            formData.append("file", file, file.name);
            xhr.send(formData);

            //下方被注释掉的是官方的一个例子
            //放到下面给大家参考

            /*var reader = new FileReader();
            reader.onload = function () {
                // Note: Now we need to register the blob in TinyMCEs image blob
                // registry. In the next release this part hopefully won't be
                // necessary, as we are looking to handle it internally.
                var id = 'blobid' + (new Date()).getTime();
                var blobCache =  tinymce.activeEditor.editorUpload.blobCache;
                var base64 = reader.result.split(',')[1];
                var blobInfo = blobCache.create(id, file, base64);
                blobCache.add(blobInfo);

                // call the callback and populate the Title field with the file name
                callback(blobInfo.blobUri(), { title: file.name });
            };
            reader.readAsDataURL(file);*/
          };
        },
      },
      lineBody: this.value,
    };
  },
  //props: ["clientId"],
  methods: {
    async createOutline() {
      try {
        const params = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          lineName: this.model.lineName,
          lineBody: this.model.lineBody,
          lineAuthor: this.model.lineAuthor,
          province: this.model.province,
          prCode: this.model.prCode,
          city: this.model.city,
          ciCode: this.model.ciCode,
          area: this.model.area,
          arCode: this.model.arCode,
          lineID: this.lineID,
        };
        const res = await this.$http.post("/outline/create", params);
        if (res.status == 200) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
        }
        this.$router.push("/outline/list");
      } catch (error) {
        console.log(error);
      }
    },
    /*    async getNewsCate() {
      try {
        const getnewscate = await this.$http.get("/newscate/getnewscate");
        this.newscate = getnewscate.data;
      } catch (error) {
        console.log(error);
      }
    }, */
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getlesson(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },

    selectProvince({ code, value }) {
      try {
        this.model.province = value;
        this.model.prCode = code;
      } catch (error) {
        console.log(error);
      }

      //console.log({ code, value });
    },
    selectCity({ code, value }) {
      try {
        this.model.city = value;
        this.model.ciCode = code;
      } catch (error) {
        console.log(error);
      }

      //console.log({ code, value });
    },
    selectArea({ code, value }) {
      try {
        this.model.area = value;
        this.model.arCode = code;
      } catch (error) {
        console.log(error);
      }

      //console.log({ code, value });
    },
    // 添加相关的事件，可用的事件参照文档=> https://github.com/tinymce/tinymce-vue => All available events
    // 需要什么事件可以自己增加
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.lineBody = "";
    },
    //生成大纲名称lineID
    createLineID() {
      this.lineID = Date.now();
    },
  },

  created() {
    this.getMajor();
    this.getChannel();
    this.createLineID();
  },
  mounted() {
    tinymce.init({});
  },
  watch: {
    value(newValue) {
      this.lineBody = newValue;
    },
    lineBody(newValue) {
      this.$emit("input", newValue);
    },
  },
};
</script>

<style></style>
